module.exports = __webpack_public_path__ + "img/image_speech@2x.9046792f.png";